export default __webpack_public_path__ + "static/media/closeIcon.f0026f7e.svg";